
// resim v .storybook preview.js
// import gsap from "gsap";

// console.log('effects');

class upceEffects {

	/**
	 * 
	 */
	constructor(element) {
	
		this.element = element;	
		
		this.data = this.parseData(element);
		// this.data = setDefaultParams(data);

		return true;

	}

	// setDefaultParams() {
	// 	defaultParams = {
	// 		delay: 3,
	// 		duration: 3,			
	// 	}
	// }

	parseData(element) {		
		
		const data_effect = element.dataset.effect;
		const data = JSON.parse(data_effect);
		return data;

	}

}

// workaround kvuli dostupnosti
window.upceEffects = upceEffects;
